const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 0,
  x2: 1,
  y1: 1,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00BD78"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#00E994",
  stopOpacity: 100
})));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M-1-1h42v42H-1z"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  stroke: "null",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20z",
  fill: "url(#a)"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M26.784 13.302a1 1 0 011.432 1.396l-10.265 10.5a1 1 0 01-1.493-.07l-3.235-4a1 1 0 011.555-1.257l2.527 2.125 9.48-8.694h-.001z",
  fill: "#fff"
});
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.0ce960f4.svg";
export { ForwardRef as ReactComponent };